export { type BasicContentProps, default } from './BasicContent';
